// nl.skills.assignmentType should replace modules.skills.assignmentType.value in locales.ts once all usages are updated to use the new keys

export default {
    nl: {
        actions: {
            accept: 'Accepteren',
            add: 'Toevoegen',
            cancel: 'Annuleren',
            delete: 'Verwijderen',
            filter: 'Filteren',
            reject: 'Afwijzen',
        },
        activities: 'Activiteiten',
        activity: 'Activiteit',
        assessor: 'Beoordelaar',
        assessors: 'Beoordelaars',
        domain: 'Domein',
        skill: 'Bekwaamheid',
        skills: 'Bekwaamheden',
        username: 'Gebruikersnaam',
        // ns = namespace, used to group related translations without nesting in the object structure
        ns: {
            skills: {
                assignmentType: {
                    all: 'Alle afdelingen & functies',
                    department: 'Afdeling (ongeacht functie)',
                    departmentrole: 'Specifieke Afdeling / Functie combinatie',
                    everyone: 'Iedereen in organisatie',
                    individual: 'Individueel',
                    role: 'Functie (ongeacht afdeling)',
                },
            },
        },
    },
    en: {
        actions: {
            accept: 'Accept',
            add: 'Add',
            cancel: 'Cancel',
            delete: 'Delete',
            filter: 'Filter',
            reject: 'Reject',
        },
        activities: 'Activities',
        activity: 'Activity',
        assessor: 'Assessor',
        assessors: 'Assessors',
        domain: 'Domain',
        skill: 'Skill',
        skills: 'Skills',
        username: 'Username',
        // ns = namespace, used to group related translations without nesting in the object structure
        ns: {
            skills: {
                assignmentType: {
                    all: 'All departments & roles',
                    department: 'Department (regardless of role)',
                    departmentrole: 'Specific Department / Role combination',
                    everyone: 'Everyone in organization',
                    individual: 'Individual',
                    role: 'Role (regardless of department)',
                },
            },
        },
    },
};
